import { Platform } from "react-native";
import { useWindowDimensions } from "react-native";

export const useWebSafeArea = () => {
  const { height } = useWindowDimensions();
  return Platform.OS === "web" ? { height } : {};
};
